import { FC } from 'react';

import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@mui/material';

import MetadataDefinitions from '@/shared/types/metadata/metadataDefinitions.type';

type MultiSelectMetadataProps = {
  optionalMetadata: MetadataDefinitions[];
  selectedMetadata: string[];
  onSelectMetadata: (selectedKeys: string[]) => void;
};

const MultiSelectMetadata: FC<MultiSelectMetadataProps> = ({
  optionalMetadata,
  selectedMetadata,
  onSelectMetadata,
}) => {
  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id='multiple-checkbox-label'>Metadata</InputLabel>
        <Select
          labelId='multiple-checkbox-label'
          id='multiple-checkbox'
          multiple
          displayEmpty
          value={selectedMetadata}
          onChange={(e) => onSelectMetadata(e.target.value as string[])}
          input={<OutlinedInput label='Metadata' />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return (
                <Typography variant='body1' sx={{ color: 'text.secondary' }}>
                  Select Metadata...
                </Typography>
              );
            }

            return (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} />
                ))}
              </Box>
            );
          }}
        >
          {optionalMetadata.map((definition) => (
            <MenuItem
              key={definition.metadata_key}
              value={definition.metadata_key}
            >
              <Checkbox
                checked={selectedMetadata.some(
                  (item) => item === definition.metadata_key,
                )}
              />
              <ListItemText primary={definition.metadata_key} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MultiSelectMetadata;
